import { render, staticRenderFns } from "./ClientVerticalMenu.vue?vue&type=template&id=ffe1820e&scoped=true"
import script from "./ClientVerticalMenu.vue?vue&type=script&lang=js"
export * from "./ClientVerticalMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe1820e",
  null
  
)

export default component.exports